<template>
  <div>
    <!-- Tìm kiếm -->
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i>
          <span class="card-label fs-3 ms-1">Xếp hạng cửa hàng</span>
        </h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Tên:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-input placeholder="Nhập tên cửa hàng" v-model="search.shopName" />
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Chọn trạng thái" v-model="search.status">
                  <el-option label="Tất cả" value="5"></el-option>
                  <el-option label="Bình thường" value="2"></el-option>
                  <el-option label="Đã xóa" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div style="padding: 5px 10px" class="form-row w-100 d-flex flex-row justify-content-between">
          <div class="col-md-6">
            <el-button type="primary" outline native-type="submit" @click="handleDownloadRanking">
              <span class="btn-inner--icon"><i class="fa fa-download"></i></span>
              <span class="btn-inner--text">&nbsp;Xuất bảng xếp hạng</span>
            </el-button>
          </div>
          <div class="col-md-6" style="text-align:right">
            <el-button plain style="margin-right:30px" title="Đồng bộ" type="warning"
              @click="handleSyncData" v-loading.fullscreen.lock="isLoading"><i class="el-icon-refresh"></i></el-button>
            <!-- <el-button plain icon="el-icon-s-grid" ></el-button> -->
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" fit stripe
          highlight-current-row>
            <el-table-column prop="cTenCuaHang" label="Tên công ty"></el-table-column>
            <el-table-column prop="cDiaChi" label="Địa chỉ"></el-table-column>
            <el-table-column prop="cDienThoai" label="Điện thoại"></el-table-column>
            <el-table-column prop="fDanhGia" align="center" label="Đánh giá">
              <template #default="scope">
                {{ scope.row.fDanhGia }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="" @current-change="" :current-page.sync="tableData.pageNum"
          :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { convertToMoney } from "@/utils/stringUtils";
import { saveAs } from 'file-saver'
import { useStore } from "vuex";
import { Shop } from "@/store/enums/StoreEnums";
import { ElMessage } from "element-plus";
export default {
  data() {
    return {
      store: useStore(),
      size: "",
      tableData: {
        content: [
        ]
      },
      search: {
        shopName: "",
        status: "5",
      },
      isSearchLoading: false,
      isLoading: false,
      centerDialogVisible: false,
      operation: false,
      validateForm: {

      },
      rules: {

      },
      productList: [],
      fit: "cover",
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      selected: {},
      downloadFilter: {
        shopName: "",
        status: "5",
      }
    };
  },
  methods: {
    handleSyncData() {
      this.store.dispatch(Shop.syncShop).then(res => {
        if (res.code == 200) {
          ElMessage({ message: res.msg, type: "success" })
          this.handleSearch()
        } else {
          ElMessage({ message: res.msg, type: "error" })
          this.handleSearch()
        }
      })
    },
    convertToMoney(val) {
      return convertToMoney(val) + " đ"
    },
    handleFindPage() {
      this.isSearchLoading = true
      if (typeof pageNum == "number") this.pageRequest.pageNum = pageNum;
      else this.pageRequest.pageNum = 1;

      if (typeof pageSize == "number") this.pageRequest.pageSize = pageSize;
      else this.pageRequest.pageSize = 30;

      this.pageRequest.columnFilters = {
        cTenCuaHang: { value: this.search.shopName },
        nTinhTrang: { value: this.search.status },
        ranking: { value: true }
      };

      this.store.dispatch(Shop.findPageShop, this.pageRequest).then((res) => {
        this.isSearchLoading = false
        if (res.code == 200 && res.data) {
          this.tableData = res.data;
        }
        else
          this.tableData = []
      });

    },
    handleDownloadRanking() {
      let pageRequest = {
        columnFilters: {
          cTenCuaHang: { value: "" },
          nTinhTrang: { value: "5" },
        }
      }
      this.store.dispatch(Shop.downloadShopRankingReport, pageRequest).then((res) => {
        saveAs(new Blob([res]), 'Bảng_xếp_hạng_cửa_hàng.xlsx')
      }).catch(err => {
        console.log("failed")
        console.log(err)
      })
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    }

  },
  mounted() {
    this.handleFindPage()

  },
};
</script>
<style lang="scss" scoped>
.tbl {
  height: calc(100vh - 255px);
}

.box-card {
  margin: 10px;
}
</style>